export default __webpack_public_path__ + "static/media/predrag-rmus.aaa44de0.jpg";